import * as React from 'react';
import { Text } from '@qga/roo-ui/components';

export const Heading = ({ children }: React.PropsWithChildren<any>) => (
  <Text color="greys.mineShaft" fontWeight="normal" fontSize={20} mt={['12px', '15px']} mb={0} lineHeight={[1.2, 1.25]}>
    {children}
  </Text>
);
